import { motion } from "framer-motion";
import { Scale, Activity, Flower2, Droplet, Salad, Brain } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";
import { PROBLEMS } from "@/data/content";

const ICONS = { Scale, Activity, Flower2, Droplet, Salad, Brain };

export default function Problems() {
  return (
    <section className="py-24 sm:py-32 bg-cardbg" data-testid="problems-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHeading
          eyebrow="Does This Sound Familiar?"
          title="Your Health Is More Than a Number on the Scale."
          sub="Maybe you've tried diets. Maybe you've started exercising. Maybe you've promised yourself that this Monday will be different. But when work, family, stress and everyday responsibilities take over, maintaining the routine becomes difficult."
        />
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {PROBLEMS.map((p, i) => {
            const Icon = ICONS[p.icon];
            return (
              <Reveal key={p.title} delay={i * 0.07}>
                <motion.div
                  whileHover={{ y: -8 }}
                  transition={{ duration: 0.35 }}
                  className="h-full bg-ivory border border-botanical/10 rounded-3xl p-8 shadow-card hover:shadow-hover transition-shadow duration-300"
                  data-testid={`problem-card-${i}`}
                >
                  <div className="w-12 h-12 rounded-2xl bg-sagesurface flex items-center justify-center mb-5">
                    <Icon size={22} className="text-sage" />
                  </div>
                  <h3 className="font-serif text-2xl text-forest">{p.title}</h3>
                  <p className="mt-3 text-sm leading-relaxed text-inkmuted">{p.text}</p>
                </motion.div>
              </Reveal>
            );
          })}
        </div>
        <Reveal delay={0.2} className="text-center mt-16">
          <p className="font-serif italic text-2xl sm:text-3xl text-botanical text-balance">
            "You don't need more guilt. You need a system that fits your life."
          </p>
        </Reveal>
      </div>
    </section>
  );
}
